import React, { CSSProperties, ReactNode } from 'react';
import { Modal as SemanticModal } from 'semantic-ui-react';
import styled from 'styled-components';
import CloseOverlayButton from '../CloseOverlayButton';
import { theme } from '../../styles/theme';
import { floatingComponentStyles } from '../../styles/shareableStyles';
import {
  FloatingLayerProvider,
  getFloatingHostElement,
} from '../FloatingManager';

const DEFAULT_MODAL_WIDTH = 600;

interface IProps {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  header?: string;
  maxWidth?: CSSProperties['maxWidth'];
  noBodyWrapper?: boolean;
  closeOnEscape?: boolean;
}

const Container = styled.div`
  ${floatingComponentStyles};
`;
const ModalHeader = styled.div`
  padding: 18px 24px;
  border-bottom: 1px solid ${theme.colors.border};
`;
const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${theme.colors.secondary900};
`;

const ModalBody = styled.div`
  padding: 16px 24px;
  border-radius: 0;
`;

const ModalCloseAction = styled(CloseOverlayButton)`
  position: absolute;
  top: 0;
  right: -40px;
`;

const KubitModal = ({
  children,
  open,
  onClose,
  header,
  maxWidth,
  noBodyWrapper,
  closeOnEscape = true,
}: IProps) => (
  <SemanticModal
    open={open}
    onClose={onClose}
    closeIcon={<ModalCloseAction />}
    closeOnEscape={closeOnEscape}
    mountNode={getFloatingHostElement()}
    style={{
      width: '100%',
      maxWidth: maxWidth || DEFAULT_MODAL_WIDTH,
    }}
  >
    <Container>
      <FloatingLayerProvider>
        {header && (
          <ModalHeader>
            <ModalTitle>{header}</ModalTitle>
          </ModalHeader>
        )}
        {noBodyWrapper ? children : <ModalBody>{children}</ModalBody>}
      </FloatingLayerProvider>
    </Container>
  </SemanticModal>
);

export default KubitModal;
